import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormArray } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import axios from "axios";
import { Company } from "./../../../models/Company.model";
import { ContentInterface } from "../../../contracts/Content.interface";
import storageX from "src/app/storageCore/storageX";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { FormateDate } from "src/app/utils/date/formateDate";

@Component({
  selector: "app-create",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class CompanyCreateComponent implements OnInit {
  public loader = false;
  private apiBaseService: ApiBaseService;
  public errorMessage;
  public errorDebug;
  public title = "Cadastrar Empresa";
  public companyForm: FormGroup;

  public dateAnnttCadastro;
  public empresaTipoSelected;
  public empresaMatrizSelected;
  public empresaSelected;
  public empresaFilterSelected;
  public types: any = [];
  public companies: any = [];
  public companiesSelect: any = [];
  public companiesFilter: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private service: ApiBaseService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.apiBaseService = service;
  }

  ngOnInit(): void {
    this.companyForm = this.formBuilder.group(
      {
        selecaoEmpresa: [""],
        empresaMatriz: [""],
        nome: [""],
        contato: [""],
        telefone: [""],
        email: [""],
        creditoSms: [""],
        empresaTipo: [""],
        cnpj: [""],
        inscricaoEstadual: [""],
        inscricaoMunicipal: [""],
        razaoSocial: [""],
        cep: [""],
        endereco: [""],
        numero: [""],
        complemento: [""],
        bairro: [""],
        cidade: [""],
        estado: [""],
        fax: [""],
        observacao: [""],
        exibePainel: [false],

        listEmpresaAutorizacaoAntt: this.formBuilder.array([
          this.formBuilder.group({
            autorizacaoAnttId: [""],
            dataCadastro: [""],
            dataVencimento: [""],
            flagGerarAlertaVencimento: [false],
            tipoAutorizacao: [""],
            numero: [""],
          }),
        ]),

        listEmpresaSeguroRctrcList: this.formBuilder.array([
          this.formBuilder.group({
            seguroRctrcId: [""],
            dataContratacao: [""],
            dataVencimento: [""],
            flagGerarAlertaVencimento: [false],
            seguradora: [""],
            numeroApolice: [""],
          }),
        ]),
      },
      { updateOn: "blur" }
    );

    this.setup();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  get empresaAutorizacaoAnttItems(): FormArray {
    return this.companyForm.get("listEmpresaAutorizacaoAntt") as FormArray;
  }

  get empresaSeguroRctrcItems(): FormArray {
    return this.companyForm.get("listEmpresaSeguroRctrcList") as FormArray;
  }

  addAutorizacaoAnttItem(element?: any): void {
    if (element) {
      const {
        id,
        dataCadastro,
        dataVencimento,
        tipoAutorizacao,
        flagGerarAlertaVencimento,
        numero,
      } = element;

      const form = this.formBuilder.group({
        autorizacaoAnttId: [id],
        dataCadastro: [FormateDate.formateDate(new Date(dataCadastro))],
        dataVencimento: [FormateDate.formateDate(new Date(dataVencimento))],
        flagGerarAlertaVencimento: [flagGerarAlertaVencimento],
        tipoAutorizacao: [tipoAutorizacao],
        numero: [numero],
      });

      this.empresaAutorizacaoAnttItems.push(form);
      return;
    } else {
      this.empresaAutorizacaoAnttItems.push(
        this.formBuilder.group({
          autorizacaoAnttId: [""],
          dataCadastro: [""],
          dataVencimento: [""],
          flagGerarAlertaVencimento: [false],
          tipoAutorizacao: [""],
          numero: [""],
        })
      );
    }
  }

  deleteAutorizacaoAnttItem(index): void {
    this.empresaAutorizacaoAnttItems.removeAt(index);
  }

  addSeguroRctrcItem(element?: any): void {
    if (element) {
      const {
        id,
        numeroApolice,
        seguradora,
        dataContratacao,
        dataVencimento,
        flagGerarAlertaVencimento,
      } = element;

      const form = this.formBuilder.group({
        seguroRctrcId: [id],
        dataContratacao: [FormateDate.formateDate(new Date(dataContratacao))],
        dataVencimento: [FormateDate.formateDate(new Date(dataVencimento))],
        flagGerarAlertaVencimento: [flagGerarAlertaVencimento],
        seguradora: [seguradora],
        numeroApolice: [numeroApolice],
      });

      this.empresaSeguroRctrcItems.push(form);
      return;
    } else {
      this.empresaSeguroRctrcItems.push(
        this.formBuilder.group({
          seguroRctrcId: [""],
          dataContratacao: [""],
          dataVencimento: [""],
          flagGerarAlertaVencimento: [false],
          seguradora: [""],
          numeroApolice: [""],
        })
      );
    }
  }

  deleteSeguroRctrcItem(index): void {
    console.log(index);
    this.empresaSeguroRctrcItems.removeAt(index);
  }

  async setup(): Promise<void> {
    const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();
    try {
      const types = await this.apiBaseService.get<ContentInterface[]>({
        url: "empresa-tipo",
      });
      this.types = types["content"];

      const params = {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      };

      const result = await this.apiBaseService.get<any>({
        url: new Company()["nomeConsultaApiBaseGetAll"],
        params,
      });

      this.companies = result["content"];

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.companyForm.controls["creditoSms"].setValue("0");

      this.loader = false;
    } catch (error) {
      console.error("loadCompany() error", error);
    }
  }

  async searchCep(): Promise<void> {
    const cep = this.companyForm.value.cep.replace(/\D/g, "");

    if (cep !== "") {
      const cepValidatorRules = /^[0-9]{8}$/;
      if (cepValidatorRules.test(cep)) {
        const url = `https://viacep.com.br/ws/${cep}/json`;
        try {
          const { data } = await axios.get(url);
          const { logradouro, complemento, bairro, localidade, uf } = data;

          this.companyForm.controls["endereco"].setValue(logradouro);
          this.companyForm.controls["complemento"].setValue(complemento);
          this.companyForm.controls["bairro"].setValue(bairro);
          this.companyForm.controls["cidade"].setValue(localidade);
          this.companyForm.controls["estado"].setValue(uf);
        } catch (error) {
          console.log("error ", error);
        }
      }
    }
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();
    try {
      this.coverterUpperCase(this.companyForm);
      const values = this.companyForm.value;

      const autorizacaoAntt = values.listEmpresaAutorizacaoAntt.filter(
        (element) => {
          const { autorizacaoAnttId: id, tipoAutorizacao, numero } = element;
          if (tipoAutorizacao && numero) {
            delete element.autorizacaoAnttId;
            return {
              id,
              ...element,
            };
          }
        }
      );

      const seguroRctrc = values.listEmpresaSeguroRctrcList.filter(
        (element) => {
          const { seguroRctrcId: id, numeroApolice, seguradora } = element;
          if (numeroApolice && seguradora) {
            delete element.seguroRctrcId;
            return {
              id,
              ...element,
            };
          }
        }
      );

      const post = {
        ...values,
        ativo: true,
        listEmpresaAutorizacaoAnttRequest: autorizacaoAntt
          ? autorizacaoAntt
          : null,
        listEmpresaSeguroRctrcRequest: seguroRctrc ? seguroRctrc : null,
        idEmpresaTipo: parseInt(this.companyForm.value["empresaTipo"]),
        idEmpresaMatriz:
          this.empresaMatrizSelected == null
            ? null
            : parseInt(this.empresaMatrizSelected),
        idUsuarioAlteracao: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()
          ?.id,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      await this.service.post<Company>(
        new Company()["nomeConsultaApiBase"],
        post
      );
      this.spinner.hide();
      this.router.navigate(["/consulta/COMPANY_FUNCIONALIDADE"]);
    } catch (exception) {
      this.spinner.hide();
      this.errorMessage = exception.message;
      throw new EvalError(exception);
    }
  }

  public filterCompany() {
    var idEmpresa = this.empresaFilterSelected;
    var empresas = [];

    console.log(idEmpresa);

    if (idEmpresa == "Divisão") {
      this.companies.forEach((element) => {
        if (element.cnpj != null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    console.log(this.companiesFilter);
  }

  public coverterUpperCase(companyForm: FormGroup) {
    if (companyForm.get("nome").value != null) {
      companyForm
        .get("nome")
        .setValue(companyForm.get("nome").value.toUpperCase());
    }

    if (companyForm.get("contato").value != null) {
      companyForm
        .get("contato")
        .setValue(companyForm.get("contato").value.toUpperCase());
    }

    if (companyForm.get("razaoSocial").value != null) {
      companyForm
        .get("razaoSocial")
        .setValue(companyForm.get("razaoSocial").value.toUpperCase());
    }

    if (companyForm.get("endereco").value != null) {
      companyForm
        .get("endereco")
        .setValue(companyForm.get("endereco").value.toUpperCase());
    }

    if (companyForm.get("complemento").value != null) {
      companyForm
        .get("complemento")
        .setValue(companyForm.get("complemento").value.toUpperCase());
    }

    if (companyForm.get("bairro").value != null) {
      companyForm
        .get("bairro")
        .setValue(companyForm.get("bairro").value.toUpperCase());
    }

    if (companyForm.get("cidade").value != null) {
      companyForm
        .get("cidade")
        .setValue(companyForm.get("cidade").value.toUpperCase());
    }

    if (companyForm.get("estado").value != null) {
      companyForm
        .get("estado")
        .setValue(companyForm.get("estado").value.toUpperCase());
    }

    if (companyForm.get("observacao").value != null) {
      companyForm
        .get("observacao")
        .setValue(companyForm.get("observacao").value.toUpperCase());
    }
  }
}
